import { Radio } from "antd"
import { FormattedMessage } from "react-intl"
import { Field } from "redux-form"
import { required } from "src/forms/validators"
import "./style.less"
import { RadioGroupField } from "../../../inputs/connected-input-fields"

export default function MinorMajorRadioGroup({ name, disabled = false }) {
  return (
    <Field
      name={name}
      component={RadioGroupField}
      validate={[required]}
      button
      label={<FormattedMessage id="form.notification.selectType" />}
      className="radio-group radio-update-type"
      disabled={disabled}
      required={required}
    >
      <Radio key="minor" value="minor">
        <FormattedMessage id="form.notification.minorChange" />
        <p>
          <FormattedMessage id="form.notification.minorChangeDescription" />
        </p>
      </Radio>
      <Radio key="major" value="major">
        <FormattedMessage id="form.notification.majorChange" />
        <p>
          <FormattedMessage id="form.notification.majorChangeDrescription" />
        </p>
      </Radio>
    </Field>
  )
}
